export { DeleteIconComponent } from './icon';
